import { useSelector, useDispatch } from "react-redux";

import { mergeMultiplePdfs } from "utils/pdf";

import {
  setPdfFileNames,
  setPdfPreviewUrl,
  setUploadReportId,
  setExtractedPdfData,
} from "app/store/manualUpload/slice/manualUploadSlice";
import { useEffect } from "react";

const useFileUpload = ({ onUpdate, existingReportUrl, onFilesSelected }) => {
  const { uploadReportId, pdfPreviewUrl, pdfFileNames } = useSelector(
    (state) => state.manualUpload
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (existingReportUrl) {
      handleExistingReportUrl();
    }
  }, [existingReportUrl]);

  useEffect(() => {
    return () => dispatch(setUploadReportId(null));
  }, []);

  const handleExistingReportUrl = async () => {
    const reportUrlResponse = await fetch(existingReportUrl);
    if (reportUrlResponse) {
      const reportBlob = await reportUrlResponse.blob();
      const reportFile = new File([reportBlob], "report.pdf", {
        type: "application/pdf",
      });

      reportFile && handleFileUpload([reportFile]);
    }
  };

  const cancelFile = () => {
    dispatch(setPdfFileNames([]));
    dispatch(setPdfPreviewUrl(null));
    dispatch(setExtractedPdfData({}));
    onFilesSelected?.([]);
  };

  const handleMultiplePdfs = async (files) => {
    const { pdfBlob, pdfUrl, fileNames } = await mergeMultiplePdfs(files);

    dispatch(setPdfFileNames(fileNames));
    dispatch(setPdfPreviewUrl(pdfUrl));
    onFilesSelected?.(files);

    onUpdate({ report: pdfBlob });
  };

  const handleFileUpload = async (files) => {
    await handleMultiplePdfs(files);
  };
  return {
    cancelFile,
    pdfFileNames,
    pdfPreviewUrl,
    uploadReportId,
    handleFileUpload,
  };
};

export default useFileUpload;
